module.exports = __webpack_public_path__ + "static/media/ownershipEcheqs.44b29dc0.svg";